module.exports = __webpack_public_path__ + "img/13-rock.96a3d76e.svg";